import React, { useEffect } from "react";
import styles from "./Footer.module.scss";
import imgLogo from "../../../assets/images/DPIE.png";
import { ContactUsInfo } from "@onegovbugs/onegov-react-components";

const Footer = (props) => {
  useEffect(() => {
    document.getElementById("container-loader").style.display = "none";
  }, []);
  return (
    <footer>
      <>
        <ContactUsInfo
          logo={imgLogo}
          address={[
            "Wildlife Team, NPWS",
            "Department of Planning, Industry",
            "and Environment",
            "Locked Bag 5022",
            "Paramatta NSW 2150",
          ]}
          phone={"02 9585 6406"}
          email={["Scientific licences:","scientific.licensing@environment.nsw.gov.au","Other wildlife licence types:","wildlife.licensing@environment.nsw.gov.au"]}
        />

        <div className={styles.footerContainer}>
          <div className={styles.footer}>
            <p>
              We pay respect to the Traditional Custodians and First Peoples of
              NSW, and acknowledge their continued connection to their country
              and culture.
            </p>
            <small className={styles.small}>Copyright © 2021</small>
          </div>
        </div>
      </>
    </footer>
  );
};

export default Footer;
